import React from 'react';

import './style.scss';
import { Strings } from '../../../shared/constants/Constants';

const Question = ({
  question = '',
  options = [],
  questionNumber,
  selectAnswer = () => {
  },
  selectedAnswer = null,
}) => {
  return (
    <>
      <h5>{`${questionNumber}. ${question}`}</h5>
      <p className='choose-answer'>{Strings.chooseCorrectAnswer}</p>
      <div className='options'>
        {options.map((option, index) => {

          return (<div
            className={`option ${selectedAnswer === index && 'active-answer'}`}
            onClick={() => selectAnswer(index)}
            key={index}
          >
            {option}
          </div>);
        })}
      </div>
    </>
  );
};

export default Question;
